import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    jobs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_JOB_SELECT_IDS (store, ids) {
      store.jobs.selectIds = ids
    },
    REMOVE_JOB_SELECT_IDS (store, ids) {
      store.jobs.selectIds = store.jobs.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_JOB_SELECT_ID (store, id) {
      store.jobs.selectId = id
    },
    SET_JOB_FILTERS (store, filters) {
      store.jobs.filters = filters
    },
    SET_JOB_PAGINATE (store, val) {
      store.jobs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getJobs: (store, getters) => {
      return store.jobs.selectIds.map((id) => {
        return getters['entities/jobs/find'](id)
      })
    },
    getJobsFilters: (store, getters) => {
      return store.jobs.filters
    },
    getJobsPaginate: (store, getters) => {
      return store.jobs.paginate
    },
    getJob: (store, getters) => {
      return getters['entities/jobs/find'](store.jobs.selectId) || {}
    }
  },
  actions: {
    /*
    selectJobs
    */
    selectJobs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getJobs', { ...filters, abortid: 'select-jobs' })
      .then((response) => {
        commit('SET_JOB_FILTERS', filters)
        commit('SET_JOB_PAGINATE', response)
        commit('SET_JOB_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectJobs
    */
    refreshSelectJobs ({commit, dispatch, getters, state}) {
      return dispatch('selectJobs', getters.getJobsFilters)
    },
    /*
    selectJob
    */
    selectJob ({commit, dispatch, getters, state}, id) {
      return dispatch('getJobById', id)
      .then((response) => {
        commit('SET_JOB_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getJobs
    */
    getJobs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs`, { params: filters })
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: getters['entities/jobs/findIn'](response.data.docs.map(v => v._id)), // insertOrUpdate traz o resultado ordenado
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getJobById
    */
    getJobById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${id}`)
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((result) => {
        return result.jobs[0]
      })
    },
    /*
    createJob
    */
    createJob ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/jobs`, data)
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      })
    },
    /*
    createJobFromRequisition
    */
    createJobFromRequisition ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/jobs/create-from-requisition/${data.requisition_id}`, {})
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      }).catch(err => {
        if (err.response.data.name === 'UpgradeRequired') {
          dispatch('setWarn', {
            // id: id,
            title: 'Não é possível abrir a vaga',
            message: `Seu plano possui um limite de ${err.response.data.params.limit} vagas abertas simultâneas. Para abrir uma nova vaga, é necessário arquivar uma das vagas existentes ou fazer um upgrade do seu plano.`,
            status: 'danger'
          })
        }
        throw err
      })
    },
    /*
    updateJobAnalyze
    */
    updateJobOpen ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${data._id}/open`)
      .then(response => {
        return dispatch('entities/jobs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      }).catch(err => {
        if (err.response.data.name === 'UpgradeRequired') {
          dispatch('setWarn', {
            // id: id,
            title: 'Não é possível abrir a vaga',
            message: `Seu plano possui um limite de ${err.response.data.params.limit} vagas abertas simultâneas. Para abrir uma nova vaga, é necessário arquivar uma das vagas existentes ou fazer um upgrade do seu plano.`,
            status: 'danger'
          })
        }
        throw err
      })
    },
    /*
    updateJobArchive
    */
    updateJobArchive ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${data._id}/archive`, data)
      .then(response => {
        return dispatch('entities/jobs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      })
    },
    /*
    updateJob
    */
    updateJob ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      })
    },
    /*
    followJob
    */
    followJob ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${data.job_id}/${data.action}`)
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      })
    },
    /*
    deleteJob
    */
    deleteJob ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/jobs/${id}`)
      .then((response) => {
        commit('REMOVE_JOB_SELECT_IDS', [id])
        dispatch('entities/jobs/delete', id)
        return {}
      })
    },
    /*
    cloneJob
    */
    cloneJob ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/jobs/${id}/clone`)
      .then((response) => {
        return dispatch('entities/jobs/insertOrUpdate', {
          data: response.data
        })
      })
      .then((response) => {
        return response.jobs[0]
      }).catch(err => {
        if (err.response.data.name === 'UpgradeRequired') {
          dispatch('setWarn', {
            // id: id,
            title: 'Não é possível clonar a vaga',
            message: `Seu plano possui um limite de ${err.response.data.params.limit} vagas abertas simultâneas. Para abrir uma nova vaga, é necessário arquivar uma das vagas existentes ou fazer um upgrade do seu plano.`,
            status: 'danger'
          })
        }
        throw err
      })
    },
    /*
    redefinedJobApprovalflow
    */
    redefinedJobApprovalflow ({commit, dispatch, getters, state}, id) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${id}/approvalflow-redefined`, {})
      .then((response) => {
        return dispatch('entities/approvalflows/insert', {
          data: response.data
        })
      })
      .then((response) => {
        const approvalflow = response.approvalflows[0]
        dispatch('getJobById', approvalflow.job_id)
        return approvalflow
      })
    },
    /*
    socketJob
    */
    socketJob ({commit, dispatch, getters, state}, message) {
      const {
        method,
        _id
      } = message

      const ids = [...state.jobs.selectIds, state.jobs.selectId]
      if (method === 'update' && ids.includes(_id)) {
        dispatch('getJobById', _id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Job.js